module.exports = __webpack_public_path__ + "img/step5.b0736c3b.png";